<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">{{ $t('table_title.Company') }}</h5>
                            </a-col>
                        </a-row>
                    </template>
                    <template>
                        <v-data-table
                            :headers="hiddenColTable"
                            :items="companys"
                            class="elevation-1"
                            hide-default-footer
                            :loading="isLoadingCompany"
                            :loading-text="$t('cms.loading')"
                            :page="page"
                            :no-data-text="$t('cms.no_data_available')"
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-dialog v-model="dialogCU" persistent max-width="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mb-2" @click="onAddNewItem()" small>
                                                <v-icon small> mdi-plus </v-icon>
                                                {{ $t('cms.add_new') }}
                                            </v-btn>
                                        </template>

                                        <CompanyModal
                                            :cuItem="cuItem"
                                            :formTitle="formTitle"
                                            :closeCU="closeCU"
                                            :save="onSaveItem"
                                            :propsField="propsField"
                                            :columns="tableColumns"
                                            :dialogEdit="dialogEdit"
                                            v-if="dialogCU"
                                        >
                                        </CompanyModal>
                                    </v-dialog>

                                    <v-spacer></v-spacer>

                                    <div class="search">
                                        <a-select :default-value="selectedField" @change="handleChangeSelect">
                                            <a-select-option
                                                v-for="(item, index) in fieldsSearch"
                                                :key="index"
                                                :value="item.value"
                                            >
                                                {{ item.title }}
                                            </a-select-option>
                                        </a-select>
                                        <a-input-search
                                            v-model="search"
                                            :placeholder="$t('header.search')"
                                            @change="onSearchItem"
                                        />
                                    </div>

                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <ModalDelete :closeDelete="closeDelete" :deleteItemConfirm="deleteItemConfirm">
                                        </ModalDelete>
                                    </v-dialog>
                                    <v-dialog v-model="dialogNoti" max-width="500px">
                                        <ModalNoti :close="closeNoti" :message="formMessage"></ModalNoti>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.department`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.department || '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.zipcode`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <p class="mb-1">{{ item.zipcode || '-' }}</p>
                                    <!-- <p :class="renderClassStatus(item.status)">{{ item.status }}</p> -->
                                </div>
                            </template>
                            <template v-slot:[`item.note`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.note || '-' }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.created_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.updated_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.updated_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <router-link
                                    :to="{ path: `/manager?company_id=${item.id}&company_code=${item.company_code}` }"
                                >
                                    <v-btn color="indigo" class="mr-2" dark small>
                                        <v-icon left> mdi mdi-format-list-bulleted-type </v-icon>
                                        {{ $t('form.manager') }}
                                    </v-btn>
                                </router-link>
                                <v-btn color="info" class="mr-2" small @click="onUpdateItem(item)">
                                    <v-icon small> mdi-pencil </v-icon>
                                    &nbsp;{{ $t('form.edit') }}
                                </v-btn>
                                <v-btn color="error" dark small @click="onDeleteItem(item)">
                                    <v-icon small> mdi-delete </v-icon>
                                    &nbsp;{{ $t('form.delete') }}
                                </v-btn>
                            </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <f-pagination
                                v-model="page"
                                :pageSize="companyPagination.pageSize"
                                :totalItems="companyPagination.totalItems"
                                :disabled="isLoadingCompany"
                            />
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24"></a-col>
        </a-row>
    </div>
</template>

<script>
import * as _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import CompanyModal from '../../components/CMS/Modal/Company.vue';
import ModalDelete from '../../components/CMS/Modal/Delete.vue';
import ModalNoti from '../../components/CMS/Modal/Noti.vue';
import { CRUD } from '../../constants';
import { mixinFormats, mixinToasts, mixinLoadings } from '../../mixins';

export default {
    mixins: [mixinFormats, mixinToasts, mixinLoadings],
    components: { CompanyModal, ModalDelete, ModalNoti },

    data() {
        return {
            tableColumns: [
                { text: this.$t('form.company_code'), value: 'company_code', sortable: false, width: '150px' },
                { text: this.$t('form.company_name'), value: 'company_name', sortable: false, width: '200px' },
                { text: this.$t('form.email'), value: 'email', sortable: false, width: '200px' },
                {
                    text: `${this.$t('form.zipcode')}`,
                    value: 'zipcode',
                    sortable: false,
                    width: '100px',
                },
                { text: this.$t('form.department'), value: 'department', sortable: false, width: '200px' },
                { text: this.$t('form.administrator_note'), value: 'note', sortable: false, width: '200px' },
                {
                    text: this.$t('form.created_at'),
                    value: 'created_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                {
                    text: this.$t('form.updated_at'),
                    value: 'updated_at_unix_timestamp',
                    sortable: false,
                    width: '175px',
                },
                { text: this.$t('cms.action'), value: 'actions', sortable: false, width: '340px' },
            ],
            fieldsSearch: [
                {
                    title: this.$t('form.company_code'),
                    value: 'company_code',
                },
                {
                    title: this.$t('form.company_name'),
                    value: 'company_name',
                },
                {
                    title: this.$t('form.email'),
                    value: 'email',
                },
            ],
            selectedField: 'company_code',
            search: '',
            page: 1,
            cuIndex: -1,
            cuItem: {},
            cuItemDelete: {},
            dialogCU: false,
            dialogDelete: false,
            dialogNoti: false,
            dialogEdit: false,
            noImage: require('../../assets/images/no_image.jpg'),
            formMessage: '',
        };
    },
    created() {
        this.hiddenFieldModal(this.dialogEdit);
    },
    computed: {
        ...mapState('company', ['isLoadingCompany', 'companys', 'companyPagination']),
        formTitle() {
            return this.cuIndex === -1 ? this.$t('cms.new_item') : this.$t('cms.edit_item');
        },
        hiddenColTable() {
            return this.tableColumns.filter((s) => s.value !== 'password');
        },
    },
    async mounted() {
        await this.getCompanyList({ page: this.page, field: this.selectedField, search: this.search });
    },
    watch: {
        page(val) {
            this.getCompanyList({ page: val, field: this.selectedField, search: this.search });
        },
        dialogCU(val) {
            val || this.closeCU();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        dialogNoti(val) {
            val || this.closeNoti();
        },
        dialogEdit(val) {
            this.hiddenFieldModal(val);
        },
    },
    methods: {
        ...mapActions('company', ['getCompanys', 'postNewCompany', 'putOneCompany', 'deleteOneCompany']),

        // renderClassStatus(status) {
        //     if (status === 'APPROVED') {
        //         return 'mb-0 text-success';
        //     } else if (status === 'REJECTED') {
        //         return 'mb-0 text-danger';
        //     } else if (status === 'WAITING') {
        //         return 'mb-0 text-warning';
        //     }
        // },

        async getCompanyList(data) {
            this.page = data?.page || 1;
            this.selectedField = data?.field;
            this.search = data?.search || '';
            await this.getCompanys(data);
        },
        initialize() {
            this.getCompanyList({ page: 1, field: 'title', search: '' });
        },
        hiddenFieldModal(val) {
            if (val === true) {
                this.propsField = this.tableColumns.filter(
                    (s) => s.value !== 'password' && s.value !== 'created_at' && s.value !== 'updated_at',
                );
            } else {
                this.propsField = this.tableColumns.filter((s) => s.value !== 'created_at' && s.value !== 'updated_at');
            }
        },
        onAddNewItem() {
            this.dialogEdit = false;
            this.dialogCU = true;
        },
        onUpdateItem(item) {
            this.dialogEdit = true;
            this.dialogCU = true;
            this.cuIndex = this.companys.indexOf(item);
            this.cuItem = Object.assign({}, item);
        },
        onDeleteItem(item) {
            this.cuIndex = this.companys.indexOf(item);
            this.cuItemDelete = Object.assign({}, item);
            this.dialogDelete = true;
        },
        async deleteItemConfirm() {
            this.closeDelete();
            this.showLoading();
            const res = await this.deleteOneCompany(this.cuItemDelete.id);
            if (res?.isSuccess) {
                await this.getCompanyList({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.DELETE);
            } else {
                this.showError(res?.data);
            }
            this.hideLoading();
        },
        closeCU() {
            this.dialogCU = false;
            this.$nextTick(() => {
                this.cuItem = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.cuItemDelete = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeNoti() {
            this.dialogNoti = false;
        },
        async onSaveItem(callback) {
            this.showLoading();
            if (this.cuIndex === -1) {
                const res = await this.postNewCompany({ ...this.cuItem, status: 'APPROVED' });
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getCompanyList({ page: 1, field: this.selectedField, search: '' });
                    this.showSuccess(CRUD.CREATE);
                } else {
                    this.showError(res?.data);
                }
            } else {
                const res = await this.putOneCompany(this.cuItem);
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getCompanyList({ page: this.page, field: this.selectedField, search: this.search });
                    this.showSuccess(CRUD.UPDATE);
                } else {
                    this.showError(res?.data);
                }
            }
            this.hideLoading();
        },
        onSearchItem: _.debounce(function (e) {
            this.getCompanyList({ page: 1, field: this.selectedField, search: this.search });
        }, 500),
        handleChangeSelect(value) {
            this.getCompanyList({ page: 1, field: value, search: this.search });
        },
    },
};
</script>

<style lang="scss">
.search {
    & .ant-select {
        margin-right: 10px;
        width: 120px;
    }

    & .ant-input-search {
        width: 500px;
    }
}
</style>
